import React from "react";

export default function App() {
  const loadScript = function (src) {
    var tag = document.createElement("script");
    tag.defer = true;
    tag.async = false;
    tag.src = src;
    var body = document.getElementsByTagName("body")[0];
    body.appendChild(tag);
  };
  const urlParams = new URLSearchParams(window.location.search);
    const origin = urlParams.get('origin') || "IND";
    window.onSherpaEvent = (event) => {
        const elementConfig = {
            language: "en-US",
            placement: "discovery",
            travellers: [{
                nationality: '', 
                vaccinations: [{
                    type: '',
                    status: '',
                },
                ],
            },
            ],
            segments: [{
                segmentType: 'OUTBOUND',
                origin: {
                    countryCode: origin,
                },
                travelMode: 'AIR',
            }, ],
        };
        if (event.type === "sdkLoaded") {
            window.$sherpa.V2.createElement("trip", elementConfig).mount("#sherpa");
        }
    };
    loadScript("https://sdk.joinsherpa.io/widget.js?appId=sp3iJOZW1r"); 
    return (
        <div className="sherpa_container">
            <div id="sherpa"></div>
        </div>
    );
}